export default "__VITE_ASSET__Hzv1UWJm__"